import { Module } from 'vuex'

import {RootState} from "@/store";

export interface RecommendedLanguage {
  idLanguage: number | null
  languageCode: string | null
  selfTitle: string | null
  weight: number
  idLocale: number | null
  idCountry: number | null
  countryCode: string | null
}

export interface RecommendedLanguagesState {
  recommendedLanguages: RecommendedLanguage[]
}

const recommendedLanguages: Module<RecommendedLanguagesState, RootState> = {
  namespaced: true,

  state: {
    recommendedLanguages: [],
  },

  mutations: {
    setRecommendedLanguages(
      state,
      payload: { recommendedLanguages: RecommendedLanguage[] }
    ) {
      state.recommendedLanguages = payload.recommendedLanguages
    },
  },

  actions: {
    wsSetRecommendedLanguages({ commit }, payload) {
      commit('setRecommendedLanguages', payload)
    },
  },

  getters: {
    getRecommendedLanguages: (state) => state.recommendedLanguages,

    // Получить уникальные языки (без дублирования по idLanguage)
    getUniqueLanguages: (state) => {
      const uniqueLanguages = new Map<number | null, RecommendedLanguage>()

      state.recommendedLanguages.forEach(lang => {
        if (lang.idLanguage !== null) {
          if (!uniqueLanguages.has(lang.idLanguage)) {
            uniqueLanguages.set(lang.idLanguage, lang)
          }
        }
      })

      return Array.from(uniqueLanguages.values())
    },
  },
}

export default recommendedLanguages 